// extracted by mini-css-extract-plugin
module.exports = {"packingListContainer":"PackingList_packingListContainer__1ZszS","packingList":"PackingList_packingList__2Oe48","templateContent":"PackingList_templateContent__znRsI"};